import {Tag} from 'antd';
import {DailyExerciseStatus} from '@PikaDoApp/npm-pikado-logic';

interface DailyExerciseStatusTagProps {
  /** Status value; missing/undefined is treated as PENDING (legacy records). */
  status?: DailyExerciseStatus | string | null;
}

const STATUS_COLORS: Record<string, string> = {
  [DailyExerciseStatus.PENDING]: 'gold',
  [DailyExerciseStatus.APPROVED]: 'green',
  [DailyExerciseStatus.REJECTED]: 'red',
};

const normalizeStatus = (status?: DailyExerciseStatus | string | null) => {
  const normalized = String(status || '').toLowerCase();

  if (normalized === String(DailyExerciseStatus.APPROVED).toLowerCase()) {
    return DailyExerciseStatus.APPROVED;
  }

  if (normalized === String(DailyExerciseStatus.REJECTED).toLowerCase()) {
    return DailyExerciseStatus.REJECTED;
  }

  return DailyExerciseStatus.PENDING;
};

/**
 * Renders an approval-status badge. Legacy exercises without a status are
 * shown as "PENDING" to match the review-queue behavior.
 */
export const DailyExerciseStatusTag = ({
  status,
}: DailyExerciseStatusTagProps) => {
  const effective = normalizeStatus(status);
  const color = STATUS_COLORS[effective] ?? 'default';
  return <Tag color={color}>{String(effective).toUpperCase()}</Tag>;
};
